export default __webpack_public_path__ + "static/media/sage-brown.4c0cad1f.jpg";